import currentPackage from '../package.json';
import Vue from 'vue';

import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'prismjs';
import 'prismjs/themes/prism.css';
import 'prismjs/plugins/autolinker/prism-autolinker.min';
import 'prismjs/plugins/autolinker/prism-autolinker.css';
import i18n from './lang';
import './style/index.scss';
console.log(currentPackage.version);
// Define custom Error for api services
window.ApiError = function(object) {
  this.data = object;
};
window.ApiError.prototype = Object.create(Error.prototype);
window.ApiError.prototype.constructor = window.ApiError;

Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
});

Vue.config.productionTip = false;

new Vue({
  i18n,
  render: (h) => h(App),
}).$mount('#app');
